import { Cookiebar, OnlineOfflineAlert, RfhTheme, AppConfigInfoDisplay } from '@rfh/ui'
import { useTranslation } from 'react-i18next'
import AppBar from './components/AppBar'
import { BrowserRouter as Router, Route, useHistory } from 'react-router-dom'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import { Config } from './configs/Config'
import AppRoutes from './components/AppRoutes'
import ErrorSnackbar from './components/ErrorSnackbar'
import { QueryClientProvider } from 'react-query'
import { QueryClient } from './services/api/QueryClient'
import { ReactQueryDevtools } from 'react-query/devtools'
import { useForceHardLocationReload } from './hooks'
import UserInformation from './components/UserInformation'
import './App.css'
import { Box, makeStyles } from '@material-ui/core'
import WarningSnackbar from './components/WarningSnackbar'

const useStyles = makeStyles({
  flexNoShrink: {
    '& > *:not(:last-child)': {
      flexShrink: 0,
    },
  },
})

export const oktaAuth = new OktaAuth(Config.oidc)
const App = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  useForceHardLocationReload()

  return (
    <RfhTheme>
      <QueryClientProvider client={QueryClient}>
        <Box
          display='flex'
          flexDirection='column'
          height='100vh'
          className={classes.flexNoShrink}
        >
          <Router>
            <Route
              exact={true}
              path='/appconfig'
              render={() => <AppConfigInfoDisplay configObject={Config} />}
            />
          </Router>

          <OnlineOfflineAlert
            offlineMessage={t('general:offlineMessage')}
            onlineMessage={t('general:onlineMessage')}
          />
          <Router>
            <RouterContent />
          </Router>
        </Box>
        {process.env.NODE_ENV !== 'production' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </RfhTheme>
  )
}

const RouterContent = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: any) => {
    history.replace(toRelativeUrl(originalUri, window.location.origin))
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Cookiebar
        title={t('general:cookieStatement')}
        messageText={t('general:useCookies')}
        linkText={t('general:showMore')}
        linkHref={t('general:cookieStatementUrl')}
      />
      <AppBar />
      <UserInformation />
      <ErrorSnackbar />
      <WarningSnackbar />
      <Box overflow='auto' display='flex' flexDirection='column'>
        <AppRoutes />
      </Box>
    </Security>
  )
}

export default App
